import {useContext, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import AuthContext from "context/AuthContext";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import NavBreadcrum from "components/NavBreadcrum";
import TableRegistred from "./plugins/TablePlugins";
import FormParams from "./plugins/FormParams";
import SwalAlert from "core/swalAlert";


import navs from "./navs";
import axiApi from "ApiCaller";

const stepTabsStatus = {
    //Status disabled tabs
    select: false,
    params: true,
}

const plugEmpty = {
    name: "",
    slug: "",
    version: "",
    description: "",
    params: {},
    key: "",
    callbacks: []
}

function ViewPluginsRegister() {
    const {user} = useContext(AuthContext);
    const navigate = useNavigate();
    const {t: _Tr} = useTranslation("routes");
    const [tF] = useTranslation("forms");
    const swalShow = new SwalAlert(tF("labels.accept"))
    const title = tF("labels.plugins-add")
    const bread = [
        {name: _Tr("labels.administration"), url: "/administration", current: false},
        {name: _Tr("labels.plugins"), current: true},
        {name: title, current: true}
    ];

    const [callbacks, setCallbacks] = useState([])


    const [keyTab, setKeyTab] = useState('select');
    const [statusTabs, setStatusTabs] = useState(stepTabsStatus);
    const [plugSelected, setPlugSelected] = useState(plugEmpty);

    const clickRadioPlugin = (e) => {
        let call = callbacks[e.target.dataset.idx];
        setPlugSelected(call)
    }
    const clickNext = () => {
        if (!plugSelected.key) {
            swalShow.warning(
                "Falta parametro",
                "Se necesita seleccionar un plugin"
            )
            return false;
        }
        setStatusTabs({...statusTabs, params: false});
        setKeyTab("params")
    }
    const onChangeParams = (e) => {
        const {name, value} = e.target;
        let plugin = {...plugSelected};
        plugin.params[name].value = value;
        setPlugSelected(plugin);

    }
    const submitParams = (e) => {
        e.preventDefault();
        axiApi.post("/api/plugin/register/", {plugin: plugSelected})
            .then((resp) => {
                if (resp.data.status) {
                    swalShow.success(
                        tF("labels.success"),
                        tF("plugin.registered")
                    ).then(() => {
                        navigate("/administration/plugins/")
                    });
                }
            })
            .catch((error) => {
                console.error(error)
                swalShow.error(
                    tF("errors.title"),
                    tF("errors.server-error")
                )
            })

    }
    useEffect(() => {
        document.title = title
        axiApi.get("/api/plugins/available/").then((resp) => {
            if (resp.data.status) {
                if (resp.data.items.length) {
                    setCallbacks(resp.data.items);
                } else {
                    swalShow.info(
                        tF("plugin.title-not-continue"),
                        tF("plugin.description-not-continue")
                    ).then(() => {
                        navigate("/administration/plugins/");
                    })
                }
            }
        }).catch((error) => {
            console.error(error)
            swalShow.error(
                tF("errors.title"),
                tF("errors.server-error")
            )
        });
    }, []);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread}/>
            <div className="col-12 preview-canvas offcanvas-header mt-1">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="plug"/>
                </div>

                <div className="preview-title ps-4">
                    <h5>Cliente: {user.organization.client}-{user.panel.project}</h5>
                </div>
            </div>

            <Tabs
                activeKey={keyTab}
                id="plugins-add-form"
                onSelect={(k) => setKeyTab(k)}
                className="mb-3"
                justify
            >
                <Tab eventKey="select" title={tF("labels.select-plugin")}>
                    <TableRegistred items={callbacks} onClickRow={clickRadioPlugin}/>
                    <div className="col-12 text-end">
                        <button type="button" onClick={clickNext} className="btn btn-primary btn-sm">Siguiente</button>
                    </div>
                </Tab>
                <Tab eventKey="params" title={tF("labels.params")} disabled={statusTabs.params}>
                    <FormParams
                        submitParams={submitParams}
                        plugSelected={plugSelected}
                        onChangeParams={onChangeParams}
                    />
                </Tab>
            </Tabs>
        </>
    );
}

export default ViewPluginsRegister;